import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectIsFrequencyManageOptimizeFlagOn } from 'core/userContext';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { AiColor16 } from 'ui/icons';
import { Menu } from 'ui/menu';
import { spacing } from 'ui/theme';
import { GhostButton } from 'ui/button';
import { InputSearch } from 'ui/inputs/inputSearch';
import { useFiltersContext } from 'modules/frequencyManagement/contexts/FiltersContext';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { Filters } from 'modules/frequencyManagement/contexts/FiltersProvider';
import { MessageMedium } from 'constants/messageMediums';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${spacing.half};
`;

const InlineFlexBetween = styled.div`
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  gap: ${spacing.half};
  min-width: ${pxToRem(120)};
`;

const InputSearchFixedWidth = styled(InputSearch)`
  width: ${pxToRem(182)};
`;

export const FiltersAndSearch = ({ messageMedium }: { messageMedium: MessageMedium }) => {
  const isOptimizeEnabled = useSelector(selectIsFrequencyManageOptimizeFlagOn);
  const { search, setSearch, filters, toggleFilter, clearFilters } = useFiltersContext();

  return (
    <Wrapper>
      {filters.size > 0 && <GhostButton onClick={clearFilters}>Clear</GhostButton>}
      <Menu
        options={[
          {
            id: Filters.IS_OFF,
            label: `Use ${lowerCaseMessageMedium(messageMedium)} rule`,
          },
          {
            id: Filters.IS_NO_CAP,
            label: 'No cap',
          },
          {
            id: Filters.IS_CAP,
            label: 'Fixed cap',
          },
          ...(isOptimizeEnabled
            ? [
                {
                  id: Filters.IS_OPTIMIZE,
                  children: (
                    <InlineFlexBetween>
                      <span>Optimize</span>
                      <AiColor16 />
                    </InlineFlexBetween>
                  ),
                },
              ]
            : []),
        ]}
        defaultSelectedOptionIds={Array.from(filters.values())}
        handleSelectionChange={(val: string) => {
          toggleFilter(val as Filters);
        }}
        isSelectMenu
      >
        <FilterMenuTriggerButton selectedFilterCount={filters.size} />
      </Menu>
      <InputSearchFixedWidth
        id="frequency-management-search"
        value={search}
        onChange={setSearch}
        placeholder="Search message types"
      />
    </Wrapper>
  );
};
